const OpportunitiesTerms = () => (
  <div>
    <h3 className="tw-font-semibold tw-mt-0">Opportunities Terms of Use</h3>
    <p>
      Brivity provides Opportunities as an add on subscription. The Opportunities subscription provides you
      with access to information about consumers with canceled and expired listings, for sale by owner
      properties and pre-foreclosure properties. This information is integrated directly within the Brivity
      Platform if you subscribe. You agree that you are solely responsible for using the information
      associated with the Opportunities subscription in accordance with all applicable laws and regulations.
      You agree to comply with all laws and regulations, including those applicable to the data provided and
      communications made using the data provided, such as data privacy laws, “do not call” rules and
      regulations, telemarketing laws, carrier rules pertaining to mobile devices and text messaging, and
      regulations governing email.
    </p>
    <p>
      You agree that the credit card on file for your Brivity Platform subscription will be charged until you
      terminate your Opportunities subscription and that you have the authority to authorize charges on the
      credit card and accept the Terms of Service and Privacy Policy related to your purchase. Your credit
      card will be charged a pro-rated amount for the first month up until your regularly scheduled Brivity
      Platform recurring monthly billing date. Thereafter, your credit card will be charged monthly for the
      Opportunities subscription at the same time as your recurring monthly billing date for your Brivity
      Platform subscription. You may terminate or modify your Opportunities subscription at any time by
      reaching out to Brivity Support at (855) 427-4848. Upon termination, you will not be charged your next
      recurring payment, and your access to Opportunities will cease at your next Brivity Platform recurring
      bill date. No refunds or pro-rated rebates will be given if you cancel prior to your recurring monthly
      billing date.
    </p>
    <p>
      By selecting the checkbox below and proceeding with the purchase, the Brivity account owner agrees
      without reservation or limitation to defend, indemnify and hold harmless Brivity, Inc. and its
      affiliates and their respective directors, officers, employees and agents from and against any and all
      losses, damages, claims, liabilities, fines, judgments, settlements, actions, suits, proceedings,
      litigation, investigations, legal costs and expenses and demands made by any party due to or arising out
      of the use of Brivity’s Platform and Services (including Opportunities) by the Brivity account owner
      and/or his, her or its employees, agents, affiliates or representatives using the Brivity account
    </p>
  </div>
);

export default OpportunitiesTerms;
